import React, { memo, forwardRef } from "react";
const SvgElementof = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M23 22a1 1 0 110 2h-7a8 8 0 110-16h7a1 1 0 110 2h-7a6.002 6.002 0 00-5.917 5H22a1 1 0 110 2H10.083A6.002 6.002 0 0016 22h7z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgElementof.displayName = "SvgElementof";
const MemoForwardRef = memo(SvgElementof);
export default MemoForwardRef;
